// VAT rates mapping by country code
export const getVatRateByCountryCode = [
  { code: 'AT', name: 'Austria', rate: 20 },
  { code: 'BE', name: 'Belgium', rate: 21 },
  { code: 'BG', name: 'Bulgaria', rate: 20 },
  { code: 'HR', name: 'Croatia', rate: 25 },
  { code: 'CY', name: 'Cyprus', rate: 19 },
  { code: 'CZ', name: 'Czech Republic', rate: 21 },
  { code: 'DK', name: 'Denmark', rate: 25 },
  { code: 'EE', name: 'Estonia', rate: 24 },
  { code: 'FI', name: 'Finland', rate: 25.5 },
  { code: 'FR', name: 'France', rate: 20 },
  { code: 'DE', name: 'Germany', rate: 19 },
  { code: 'GR', name: 'Greece', rate: 24 },
  { code: 'HU', name: 'Hungary', rate: 27 },
  { code: 'IE', name: 'Ireland', rate: 23 },
  { code: 'IT', name: 'Italy', rate: 22 },
  { code: 'LV', name: 'Latvia', rate: 21 },
  { code: 'LT', name: 'Lithuania', rate: 21 },
  { code: 'LU', name: 'Luxembourg', rate: 17 },
  { code: 'MT', name: 'Malta', rate: 18 },
  { code: 'NL', name: 'Netherlands', rate: 21 },
  { code: 'PL', name: 'Poland', rate: 23 },
  { code: 'PT', name: 'Portugal', rate: 23 },
  { code: 'RO', name: 'Romania', rate: 21 },
  { code: 'SK', name: 'Slovakia', rate: 23 },
  { code: 'SI', name: 'Slovenia', rate: 22 },
  { code: 'ES', name: 'Spain', rate: 21 },
  { code: 'SE', name: 'Sweden', rate: 25 },
  { code: 'GB', name: 'United Kingdom', rate: 20 },
  { code: 'IN', name: 'India', rate: 18 }, // will be removed later
];


export const getVatRateByCountryCode_1 = [
  { code: 'AT', name: 'Austria', rate: 20 },
  { code: 'BE', name: 'Belgium', rate: 21 },
  { code: 'BG', name: 'Bulgaria', rate: 20 },
  { code: 'HR', name: 'Croatia', rate: 25 },
  { code: 'CY', name: 'Cyprus', rate: 19 },
  { code: 'CZ', name: 'Czech Republic', rate: 21 },
  { code: 'DK', name: 'Denmark', rate: 25 },
  { code: 'EE', name: 'Estonia', rate: 22 },
  { code: 'FI', name: 'Finland', rate: 25.5 },
  { code: 'FR', name: 'France', rate: 20 },
  { code: 'DE', name: 'Germany', rate: 19 },
  { code: 'GR', name: 'Greece', rate: 24 },
  { code: 'HU', name: 'Hungary', rate: 27 },
  { code: 'IE', name: 'Ireland', rate: 23 },
  { code: 'IT', name: 'Italy', rate: 22 },
  { code: 'LV', name: 'Latvia', rate: 21 },
  { code: 'LT', name: 'Lithuania', rate: 21 },
  { code: 'LU', name: 'Luxembourg', rate: 17 },
  { code: 'MT', name: 'Malta', rate: 18 },
  { code: 'NL', name: 'Netherlands', rate: 21 },
  { code: 'PL', name: 'Poland', rate: 23 },
  { code: 'PT', name: 'Portugal', rate: 23 },
  { code: 'RO', name: 'Romania', rate: 19 },
  { code: 'SK', name: 'Slovakia', rate: 23 },
  { code: 'SI', name: 'Slovenia', rate: 22 },
  { code: 'ES', name: 'Spain', rate: 21 },
  { code: 'SE', name: 'Sweden', rate: 25 },
  { code: 'GB', name: 'United Kingdom', rate: 20 },
  { code: 'IN', name: 'India', rate: 18 }, // will be removed later
];
